<template>
  <div>
    <div
      v-for="(item, index) in colors"
      :key="`${index}-${item.color}`"
      class="block"
      :style="{ background: item.color }"
    ></div>
  </div>
</template>
<script>
export default {
  name: "color-fade",
  props: {
    colors: Array,
  },
};
</script>
